var render, staticRenderFns
import script from "./CampaignStackBarChart.vue?vue&type=script&lang=js&"
export * from "./CampaignStackBarChart.vue?vue&type=script&lang=js&"
import style0 from "./CampaignStackBarChart.vue?vue&type=style&index=0&id=0ec47a23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec47a23",
  null
  
)

export default component.exports